exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* Sidebar background color */\n/* Sidebar header and footer color */\n/* Sidebar title text colour */\n/* Sidebar menu item hover color */\n.texts-danger {\n  color: #F68C1F; }\n\n.texts-success {\n  color: #00A85F; }\n\n.text-stop {\n  color: #ED1C24; }\n\n.spog-modal .modal-row span {\n  font-family: Rubik-Medium; }\n\n.spog-modal .modal-row .new-features {\n  margin-bottom: 10px; }\n\n.spog-modal .modal-message {\n  font-size: 1.2em; }\n\n.spog-modal .modal-footer {\n  text-align: left; }\n\n@media (min-width: 768px) {\n  .spog-modal .modal-large.modal-large.modal-large.modal-large.modal-large.modal-large.modal-large.modal-large {\n    width: 1200px; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./node_modules/sass-loader/lib/loader.js!./src/style/components/ui/layout/panel/spog-modal.scss
// module id = 1203
// module chunks = 49